import React, { Component } from "react";
import styles from "./Components.local.scss";
import {
  setSideBar,
  setSelectedCase,
  setSelectedComponent,
  initComponentConfig
} from "Actions";
import { connect } from "react-redux";
import { ICONS, SvgIcon } from "../../Common/Icons";
import classnames from "classnames";
import { onError } from "Utils";
import _ from "i18n";

class EmptyComponent extends Component {
  handleChangeSideBar = sideBar => {
    const { dispatch, composition } = this.props;
    if (
      composition.labels["fr"].length === 0 &&
      composition.labels["en"].length === 0 &&
      composition.labels["nl"].length === 0
    ) {
      onError(_("msgEmptyField"));
    } else {
      dispatch(initComponentConfig());
      dispatch(setSideBar(sideBar));
      dispatch(setSelectedCase(this.props.selectedCaseProps));
      dispatch(setSelectedComponent(""));
    }
  };

  render() {
    const selectedCaseProps = this.props.selectedCaseProps;

    const {
      selectedComponent,
      selectCase,
      componentsBackground,
      fetching
    } = this.props;

    const customBackground = {
      background: componentsBackground
    };

    return (
      <button
        className={classnames(
          styles.icon_plus,
          selectedCaseProps === selectCase ? styles.selected_case : ""
        )}
        style={customBackground}
        onClick={() => this.handleChangeSideBar("ComponentList")}
      >
        {fetching &&
          selectedCaseProps === selectCase &&
          selectedComponent !== "" && (
            <div className={styles.ripple_loading}>
              <img src={"/img/Ripple-1s-150px.svg"} alt="" />
            </div>
          )}
        {selectedCaseProps === selectCase && selectedComponent !== "" ? (
          !fetching && (
            <img
              src={`/img/slide-composition/component-image/${selectedComponent}`}
              alt={""}
              className={styles.component_img}
            />
          )
        ) : (
          <SvgIcon
            icon={ICONS.PLUS_ICON}
            className={
              selectedCaseProps === selectCase && selectedComponent === ""
                ? styles.selected_component
                : ""
            }
          />
        )}
      </button>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  selectCase: state.slideComposition.composition.layout.selectedCase,
  selectedComponent: state.slideComposition.composition.selectedComponent,
  componentsBackground:
    state.slideComposition.composition.layout.config.componentsBackground,
  composition: state.slideComposition.composition,
  fetching: state.slideComposition.fetchSlide.fetching
});

export default connect(mapStateToProps)(EmptyComponent);



// WEBPACK FOOTER //
// ./src/components/Dashboard/Components/EmptyComponent.js